import { render } from "./ProcedureCreate.vue?vue&type=template&id=60f553b6"
import script from "./ProcedureCreate.vue?vue&type=script&lang=js"
export * from "./ProcedureCreate.vue?vue&type=script&lang=js"

import "./ProcedureCreate.vue?vue&type=style&index=0&id=60f553b6&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__